document.addEventListener('DOMContentLoaded', () => {
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const COUNT_DURATION = 1200;
  const COUNT_STAGGER = 120;
  const NUM_RE = /\d+(?:\.\d+)?/g;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  /* Format an intermediate value to match the original token:
     keeps decimal places and leading-zero padding ("02" counts 00 -> 02). */
  function formatToken(token, value) {
    const decimals = token.includes('.') ? token.split('.')[1].length : 0;
    let out = value.toFixed(decimals);
    if (/^0\d/.test(token)) {
      const intLength = token.split('.')[0].length;
      const parts = out.split('.');
      parts[0] = parts[0].padStart(intLength, '0');
      out = parts.join('.');
    }
    return out;
  }

  function prepareCounters(root) {
    root.querySelectorAll('[data-sf-count]').forEach((el) => {
      const finalText = el.textContent.trim();
      el.dataset.sfFinal = finalText;
      el.setAttribute('aria-label', finalText);
      el.textContent = finalText.replace(NUM_RE, (token) => formatToken(token, 0));
    });
  }

  function runCounter(el, delay) {
    const finalText = el.dataset.sfFinal || el.textContent;
    let start = null;

    function frame(now) {
      if (start === null) start = now;
      const progress = Math.min((now - start) / COUNT_DURATION, 1);
      const eased = easeOutCubic(progress);
      el.textContent = finalText.replace(NUM_RE, (token) => formatToken(token, parseFloat(token) * eased));
      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = finalText;
      }
    }

    setTimeout(() => requestAnimationFrame(frame), delay);
  }

  function initSection(root) {
    if (root.dataset.sfInit) return;
    root.dataset.sfInit = 'true';

    const counters = root.querySelectorAll('[data-sf-count]');
    if (!counters.length) return;

    if (REDUCED_MOTION || (window.Shopify && window.Shopify.designMode)) return;

    prepareCounters(root);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          entry.target.querySelectorAll('[data-sf-count]').forEach((el, index) => {
            runCounter(el, index * COUNT_STAGGER);
          });
        });
      },
      { threshold: 0.3, rootMargin: '0px 0px -60px 0px' }
    );

    observer.observe(root);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-sych-founder]').forEach(initSection);
  }

  init(document);

  document.addEventListener('shopify:section:load', (event) => init(event.target));
});
